import React from 'react'
import { EmptyContent as EmptyContentCore } from '@ztechapps/webui.util'
import { SeeOurProductsButton } from '../../../components/SeeOurProductsButton'

export const EmptyContent = ({ message = 'You dont have a favorites yet!' }) => {
  return (
    <EmptyContentCore
      icon="clipboard-list"
      message={message}
      subMessage="Search for any products and select the the 'Add to favorite' button"
      action={<SeeOurProductsButton />}
    />
  )
}
